import React, { useEffect, useState } from 'react';
import Separation from "../../../common/SeparationLine/Separation";
import SmallSeparationLine from '../../../common/SeparationLine/SmallSeparation';

const StatusMobileForm = ({
    isReadOnly,
    isSetPointloading,
    wellStatusDetails,
    statusScreenHeight,
    renderProperties,
    openModal,
    setIsValveModalOpen,
    setIsOpenValveClick,
    loading,
    isValveControlUser,
    showclearAlarmsButton

}) => {

    const hasTodayAvgArrivalVelocity =
    Object.prototype.hasOwnProperty.call(
        wellStatusDetails,
        "todayAvgArrivalVelocity"
    );

    return (
        <>
            {/* Controls */}
            {!isReadOnly && !loading && <div className="border border-darkcolor-500 bg-darkcolor-600 rounded-lg py-4 ml-4 mr-4">
                <span className="mb-3 pl-5 pt-1 block text-white">Controls</span>
                <Separation />

                <div className="pt-4">
                    <div className="flex flex-wrap justify-center" style={{ gap: "0.5rem" }}>
                        {!isReadOnly && <button
                            type="button"
                            className={`btn btn-primary text-center ${isSetPointloading ? 'disabled-button' : ''}`}
                            style={{
                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                width: "95px",
                                visibility: isReadOnly ? "hidden" : "visible", // Ensures alignment
                            }}
                            onClick={() => {
                                setIsValveModalOpen(true);
                                setIsOpenValveClick("OpenValve");
                            }}
                            disabled={isSetPointloading}
                        >
                            Open Valve
                        </button>
                        }
                        <button
                            type="button"
                            className={`btn btn-primary text-center font-medium ${(!isValveControlUser && isSetPointloading) ||
                                (isSetPointloading && !Boolean(wellStatusDetails?.openHoldEnabled)) ? 'disabled-button' : ''}`}
                            style={{
                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                width: "90px",
                                visibility: Boolean(wellStatusDetails?.openHoldEnabled) || isValveControlUser ? "visible" : "hidden", // Ensures alignment
                            }}
                            onClick={() => {
                                setIsValveModalOpen(true);
                                setIsOpenValveClick("OpenHold");
                            }}
                            disabled={(!isValveControlUser && isSetPointloading) ||
                                (isSetPointloading && !Boolean(wellStatusDetails?.openHoldEnabled))}
                        // hidden={!Boolean(wellStatusDetails?.openHoldEnabled)}
                        >
                            Hold Open
                        </button>
                        <button
                            type="button"
                            className={`btn btn-primary text-center font-medium ${(!isValveControlUser && isSetPointloading) ||
                                (isSetPointloading && !Boolean(wellStatusDetails?.catchEnabled)) ? 'disabled-button' : ''}`}
                            style={{
                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                width: "90px",
                                paddingLeft: "25px",
                                visibility: Boolean(wellStatusDetails?.catchEnabled) || isValveControlUser ? "visible" : "hidden", // Ensures alignment
                            }}
                            onClick={() => {
                                setIsValveModalOpen(true);
                                setIsOpenValveClick("Catch");
                            }}
                            disabled={(!isValveControlUser && isSetPointloading) ||
                                (isSetPointloading && !Boolean(wellStatusDetails?.catchEnabled))}
                        // hidden={!Boolean(wellStatusDetails?.catchEnabled)}
                        >
                            Catch
                        </button>
                    </div>

                    <div className="flex flex-wrap gap-2 justify-center mt-4" style={{ gap: ".5rem" }}>
                        {!isReadOnly && <button
                            type="button"
                            className={`btn btn-primary text-center font-medium ${isSetPointloading ? 'disabled-button' : ''}`}
                            style={{
                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                width: "95px",
                                visibility: isReadOnly ? "hidden" : "visible", // Ensures alignment
                            }}
                            onClick={() => {
                                setIsValveModalOpen(true);
                                setIsOpenValveClick("CloseValve");
                            }}
                            disabled={isSetPointloading}
                        >
                            Close Valve
                        </button>
                        }
                        <button
                            type="button"
                            className={`btn btn-primary text-center font-medium ${(!isValveControlUser && isSetPointloading) ||
                                (isSetPointloading && !Boolean(wellStatusDetails?.closeHoldEnabled)) ? 'disabled-button' : ''}`}
                            style={{
                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                width: "90px",
                                visibility: Boolean(wellStatusDetails?.closeHoldEnabled) || isValveControlUser ? "visible" : "hidden", // Ensures alignment
                            }}
                            onClick={() => {
                                setIsValveModalOpen(true);
                                setIsOpenValveClick("CloseHold");
                            }}
                            disabled={(!isValveControlUser && isSetPointloading) ||
                                (isSetPointloading && !Boolean(wellStatusDetails?.closeHoldEnabled))}
                        // hidden={!Boolean(wellStatusDetails?.closeHoldEnabled)}
                        >
                            Hold Close
                        </button>
                        <button
                            type="button"
                            className={`btn btn-primary text-center font-medium ${(!isValveControlUser && isSetPointloading) ||
                                (isSetPointloading && !Boolean(wellStatusDetails?.releaseEnabled)) ? 'disabled-button' : ''}`}
                            style={{
                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                width: "90px",
                                paddingLeft: "25px",
                                visibility: Boolean(wellStatusDetails?.releaseEnabled) || isValveControlUser ? "visible" : "hidden", // Ensures alignment
                            }}
                            onClick={() => {
                                setIsValveModalOpen(true);
                                setIsOpenValveClick("Release");
                            }}
                            disabled={(!isValveControlUser && isSetPointloading) ||
                                (isSetPointloading && !Boolean(wellStatusDetails?.releaseEnabled))}
                        // hidden={!Boolean(wellStatusDetails?.releaseEnabled)}
                        >
                            Release
                        </button>
                    </div>
                </div>

            </div>
            }
            <div className="overflow-x-auto w-full">

                <div className="flex flex-wrap py-4 border border-darkcolor-500 bg-darkcolor-600 rounded-lg ml-[15px] mr-[15px] mt-[10px]" style={{ height: statusScreenHeight, width: "800px" }}>
                    <div style={{ marginBottom: "20px", marginRight: "10px", width: "100%" }}>

                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                            <span style={{ marginLeft: "15px" }}>Status</span>

                        </div>
                    </div>




                    <Separation />

                    {/* Paired rendering of static and dynamic props */}
                    {[
                        {
                            label: "Last:",
                            value: wellStatusDetails?.last?.value,
                            color: wellStatusDetails?.hexcode,
                            unit: wellStatusDetails?.last?.unit

                        },
                        { label: "State:", value: wellStatusDetails?.state?.value, unit: wellStatusDetails?.state?.unit },
                        { label: "Time in State:", value: wellStatusDetails?.timeInState?.value, unit: wellStatusDetails?.timeInState?.unit },
                        { label: "Reason:", value: wellStatusDetails?.reason?.value, unit: wellStatusDetails?.reason?.unit },
                        { label: "Open Trigger:", value: wellStatusDetails?.openTrigger?.value, unit: wellStatusDetails?.openTrigger?.unit },
                        { label: "Close Trigger:", value: wellStatusDetails?.closeTrigger?.value, unit: wellStatusDetails?.closeTrigger?.unit },
                        { label: "Last Fall:", value: wellStatusDetails?.lastFall?.value, unit: wellStatusDetails?.lastFall?.unit },
                        { label: "Last Slug Vol:", value: wellStatusDetails?.lastSlugVol?.value, unit: wellStatusDetails?.lastSlugVol?.unit },
                        { label: "Last Arr Velocity:", value: wellStatusDetails?.lastArrVelocity?.value, unit: wellStatusDetails?.lastArrVelocity?.unit },
                        { label: "Last Arr Time:", value: wellStatusDetails?.lastArrTime?.value, unit: wellStatusDetails?.lastArrTime?.unit },
                        { label: "Today's Opens:", value: wellStatusDetails?.todaysOpens?.value, unit: wellStatusDetails?.todaysOpens?.unit },
                        { label: "Today's Arrivals:", value: wellStatusDetails?.todaysArrivals?.value, unit: wellStatusDetails?.todaysArrivals?.unit },
                        { label: "Today's Avg Arrival:", value: wellStatusDetails?.todaysAvgArrival?.value, unit: wellStatusDetails?.todaysAvgArrival?.unit },
                        ...(hasTodayAvgArrivalVelocity
                            ? [{
                                label: "Today's Avg Arrival Velocity:",
                                value: wellStatusDetails?.todayAvgArrivalVelocity?.value,
                                unit: wellStatusDetails?.todayAvgArrivalVelocity?.unit
                            }]
                            : []),
                        { label: "Yesterday's Opens:", value: wellStatusDetails?.yesterdayOpens?.value, unit: wellStatusDetails?.yesterdayOpens?.unit },
                        { label: "Yesterday's Arrivals:", value: wellStatusDetails?.yesterdayArrivals?.value, unit: wellStatusDetails?.yesterdayArrivals?.unit },
                        { label: "Yesterday's Avg Arrival:", value: wellStatusDetails?.yesterdaysAvgArrival?.value, unit: wellStatusDetails?.yesterdaysAvgArrival?.unit },
                        { label: "User Total Arrivals:", value: wellStatusDetails?.totalArrival?.value, unit: wellStatusDetails?.totalArrival?.unit },
                        { label: "Plunger Travel Distance:", value: wellStatusDetails?.plungerTravelDistance?.value, unit: wellStatusDetails?.plungerTravelDistance?.unit }
                    ].map((item, index, arr) => (
                        <React.Fragment key={index}>
                            <div className="flex w-full">
                                {/* Left - Static Property */}
                                <div className="flex w-1/2 ml-5 mt-2 mb-2 items-center">
                                    <p className="w-full flex justify-between">
                                        {item.label}
                                        <label className="label text-sm ml-auto" style={{ color: item.color || undefined }}>
                                            {item.value}
                                            {item.unit && (
                                                <span style={{ color: "var(--Primary-Indigo-500, #0094BD)", marginLeft: "12px" }}>
                                                    | {item.unit}
                                                </span>
                                            )}
                                        </label>
                                    </p>
                                </div>

                                {/* Right Column - Dynamic Property */}
                                <div className="flex w-[50%]">
                                    {index < renderProperties().length && renderProperties()[index]}
                                </div>
                            </div>

                            {/* Only render separation line if not the last item */}
                            {index < arr.length - 1 && <SmallSeparationLine />}
                        </React.Fragment>
                    ))}
                    {/* Alarms Section */}
                </div>
            </div>

            <div className="py-4 border border-darkcolor-500 bg-darkcolor-600 rounded-lg ml-4 mr-4" style={{ marginTop: "10px" }}>
                <span className="mb-3 pl-5 pt-3 text-white">Alarms:</span>
                {showclearAlarmsButton && (
                    <button
                        type="button"
                        className="btn btn-primary mr-2"
                        style={{ marginTop: "-10px", float: "right", backgroundColor: "var(--Primary-Indigo-700, #005F7C)", display: "inline" }}
                        onClick={() => {
                            setIsValveModalOpen(true);
                            setIsOpenValveClick("Alarms");
                        }}
                    >
                        Clear Alarms
                    </button>
                )}
                {/* <button
                        type="button"
                        className={`btn btn-primary mr-2 ${isSetPointloading ? 'disabled-button' : ''}`}
                        style={{ marginTop: "-10px", float: "right", backgroundColor: "var(--Primary-Indigo-700, #005F7C)", display: "inline" }}
                        onClick={openModal}
                        disabled={isSetPointloading}
                      >
                    Configure
                </button> */}
                <Separation />
                <div className="pl-5 mt-2" style={{ overflowX: 'auto', whiteSpace: 'nowrap', color: wellStatusDetails.alarms === "OK" ? "green" : "red" }}>
                    {wellStatusDetails?.alarms?.split(',')?.map((alarm, index) => (
                        <button
                            key={index}
                            style={{
                                marginRight: '5px',
                                marginBottom: '5px',
                                border: alarm === "OK" ? '1px solid green' : '1px solid red',
                                borderRadius: '5px',
                                padding: '5px',
                                fontSize: '12px',
                                minWidth: 'fit-content'
                            }}
                        >
                            {alarm}
                        </button>
                    ))}
                </div>
            </div>
        </>
    );
};

export default StatusMobileForm;
